/**
 * Note: all references to process.env only work in local or during the
 * CI build process
 */
import adminConfig from './admin/lumi.admin.config';
import clientConfig from './client/lumi.client.config';
import brokerConfig from './broker/lumi.broker.config'; //
import buzzConfig from './buzz/lumi.buzz.config';
import chimeraConfig from './chimera/lumi.chimera.config';

const devVersion = process.env.DEV_VERSION;
const ENVIRONMENT = process.env.NODE_ENV || 'development';
const VERSION = require('../package.json').version;

let SERVER_HOST = {
  protocol: 'http',
  websockProtocol: 'ws',
  host: 'localhost:3000',
};
let HUBSPOT_PORTAL_ID = '6212581';

let AUTH0_CLIENT_ID = 'cVBU2ky1srYi0OXqRobyhFSmjrxumFrJ';
let AUTH0_API_IDENTIFIER = 'http://localhost:3000/';
let AUTH0_MANAGEMENT_DOMAIN = 'dev-cf34dn8woy6jlxqi.us.auth0.com';

const DATABRICKS_TIME_WARNING_START =
  process.env.DATABRICKS_TIME_WARNING_START || '12.00am';
const DATABRICKS_TIME_WARNING_END =
  process.env.DATABRICKS_TIME_WARNING_END || '10.10am';

if (ENVIRONMENT === 'staging') {
  SERVER_HOST = {
    protocol: 'https',
    websockProtocol: 'wss',
    host: 'staging.lumi.com.au',
  };
  AUTH0_CLIENT_ID = '1LH8lCI8Yqdsw27HXKJQwXizupTx6cpl';
  AUTH0_API_IDENTIFIER = 'https://staging.lumi.com.au/';
}
if (devVersion && devVersion !== 'null') {
  SERVER_HOST = {
    protocol: 'https',
    websockProtocol: 'wss',
    host: `${devVersion}.lumi-tech.dev`,
  };
  AUTH0_CLIENT_ID = 'eO2JAkY0lIXmrFTeUHuJqLstG9OcmDFU';
  AUTH0_API_IDENTIFIER = 'https://auth0.lumi-tech.dev/';
}
if (ENVIRONMENT === 'production') {
  SERVER_HOST = {
    protocol: 'https',
    websockProtocol: 'wss',
    host: 'www.lumi.com.au',
  };
  HUBSPOT_PORTAL_ID = '5718736';
  // auth0 config
  AUTH0_CLIENT_ID = 'UPJeZkr32iL8pgaqR4wl6rGGf3U1Fxl8';
  AUTH0_API_IDENTIFIER = 'https://www.lumi.com.au/';
  AUTH0_MANAGEMENT_DOMAIN = 'lumi.au.auth0.com';
}

const getOverrides = (
  environment: string,
  devVersion: string | undefined,
): any => ({
  admin: adminConfig(environment, devVersion),
  client: clientConfig(environment),
  broker: brokerConfig(environment, devVersion),
  buzz: buzzConfig(environment, devVersion),
  chimera: chimeraConfig(environment),
});

const serverURL = `${SERVER_HOST.protocol}://${SERVER_HOST.host}`;
const publicServerURL = `${
  ENVIRONMENT === 'development' ? 'http://localhost:5000' : serverURL
}/public`;

export default {
  SERVER_HOST: serverURL,
  PUBLIC_SERVER_HOST: publicServerURL,
  NODE_ENVIRONMENT: ENVIRONMENT,
  IS_DEVELOPMENT: ENVIRONMENT === 'development',
  IS_TEST: ENVIRONMENT === 'test',
  IS_PRODUCTION: ENVIRONMENT === 'production',
  API_URL: `${serverURL}/api`,
  GRAPHQL_URL: `${serverURL}/graphql`,
  PUBLIC_GRAPHQL_URL: `${publicServerURL}/graphql`,
  LEADS_API_URL: `${
    ENVIRONMENT === 'development' ? 'http://localhost:5000' : serverURL
  }/v1/leads`,
  GRAPHQL_SUBSCRIPTIONS_URL: `${SERVER_HOST.websockProtocol}://${SERVER_HOST.host}/graphql`,
  VERSION,
  BASENAME: process.env.BASENAME || '',
  CLIENT: process.env.CLIENT_APPLICATION,
  AUTH0_CLIENT_ID,
  AUTH0_API_IDENTIFIER,
  AUTH0_MANAGEMENT_DOMAIN,
  ...getOverrides(ENVIRONMENT, devVersion)[process.env.CLIENT_APPLICATION],
  LOCAL_CLIENT: 'http://localhost:8080',
  LOCAL_CHIMERA: 'http://localhost:9090',
  HUBSPOT_PORTAL_ID,
  DATABRICKS_TIME_WARNING_START,
  DATABRICKS_TIME_WARNING_END,
};
